import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

export interface SkillQuestionRubricSuggestionDialogData {
  dialog_title: string;
  dialog_description: string;
  dialog_cancel_button: string;
  dialog_confirm_button: string;
}

@Component({
  selector: 'app-skill-question-rubric-suggestion-dialog',
  templateUrl: './skill-question-rubric-suggestion-dialog.component.html',
  styleUrl: './skill-question-rubric-suggestion-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, MatDialogTitle, MatDialogContent, MatDialogActions, MatButtonModule, MatFormFieldModule, MatInputModule],
})
export class SkillQuestionRubricSuggestionDialogComponent {
  private readonly dialog_ref = inject(MatDialogRef<SkillQuestionRubricSuggestionDialogComponent, string | undefined>);
  private readonly form_builder = inject(FormBuilder);

  readonly data = inject<SkillQuestionRubricSuggestionDialogData>(MAT_DIALOG_DATA);

  readonly form = this.form_builder.group({
    additional_prompt: [''],
  });

  cancel(): void {
    this.dialog_ref.close(undefined);
  }

  confirm(): void {
    const additional_prompt = this.form.controls.additional_prompt.value?.trim() ?? '';

    this.dialog_ref.close(additional_prompt);
  }
}
